const namespace = "setting";

export const setting = `${namespace}_list`;
export const setting_category = `${namespace}_category_list`;
export const setting_category_select = `${namespace}_category_select`;
export const user_select = `${namespace}_user`;
export const settingSelect = `${namespace}_select`;
export const settingSelectData = `${namespace}_select_data`;
export const typeSelect = `${namespace}_type_select`;
